// extracted by mini-css-extract-plugin
export default {"popup":"ActionDropdown_popup__a1k15","option":"ActionDropdown_option__wx3Jd"};